<template>
  <a @click="open"><slot /></a>
</template>

<script>
import { bridgeUrlClick } from 'native_bridge/bridge_url'

export default {
  props: {
    bridgeTarget: {
      type: String,
      default: 'external',
    },
  },
  methods: {
    open(event) {
      const url = this.$el.getAttribute('href')
      bridgeUrlClick(event, url, this.bridgeTarget)
    },
  },
}
</script>
